import React, { useState } from "react";
import { ChevronDown, CheckCircle2, AlertTriangle, CalendarClock } from "lucide-react";
import { T, track } from "./theme";

const CASES = [
  { k: "on_time", icon: CheckCircle2, color: "#2E7D4F", title: "Pagamento em dia", text: "Fortalece o histórico e ajuda a evitar encargos." },
  { k: "late", icon: AlertTriangle, color: "#D32F45", title: "Pagamento em atraso", text: "Pode gerar multa e juros e afetar a sua avaliação." },
  { k: "early", icon: CalendarClock, color: "#7A4FC0", title: "Pagamento antecipado", text: "Ajuda a organizar seus compromissos e evitar atrasos, mas não garante pontos adicionais." },
];

export const EducationSimulator = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="rounded-[22px] bg-white" data-testid="education-simulator">
      <button onClick={() => { if (!open) track("simulator_open"); setOpen(!open); }} aria-expanded={open}
        className="flex w-full items-center gap-3 p-4 text-left" data-testid="education-toggle">
        <span className="min-w-0 flex-1 text-[16px] font-extrabold" style={{ color: T.deep }}>Como minhas decisões influenciam meu histórico?</span>
        <ChevronDown size={20} className={`shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} style={{ color: T.muted }} />
      </button>
      {open && (
        <ul className="cc-fade space-y-2 border-t px-4 pb-4 pt-3" style={{ borderColor: T.line }} data-testid="education-cases">
          {CASES.map(({ k, icon: Icon, color, title, text }) => (
            <li key={k} className="flex items-start gap-3 rounded-2xl p-3" style={{ background: T.lavender }} data-testid={`education-case-${k}`}>
              <Icon size={20} className="mt-0.5 shrink-0" style={{ color }} />
              <span><b className="block text-[14px]" style={{ color: T.deep }}>{title}</b><span className="text-[13px]" style={{ color: T.muted }}>{text}</span></span>
            </li>
          ))}
          <li className="px-1 text-[12px]" style={{ color: T.muted }}>Simulação educativa: não altera sua pontuação real.</li>
        </ul>
      )}
    </section>
  );
};
